import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const ServiceService = {
    getServiceById: (id) => {
        return http.get(`${baseUrl}/cliami/services/${id}`);
    },

    getServices: () => {
        return http.get(`${baseUrl}/cliami/services`);
    },

    saveService: (service) => {
        if (!service.serviceId) {
            return http.post(`${baseUrl}/cliami/services/create`, service);
        } else {
            return http.put(`${baseUrl}/cliami/services/update/${service.serviceId}`, service);
        }
    },

    deleteService: (service) => {
        return http.delete(`${baseUrl}/cliami/services/delete/${service.serviceId}`);
    },
};

export default ServiceService;
